// extracted by mini-css-extract-plugin
export var content = "blogTemplate-module--content--53c32";